import { NoticeType, showNoticeMessage } from '../../actions/grid-screen';

export const ERROR_PROPORTION_CHECKPOINT = 0.2;
export const SUCCESS_PROPORTION_CHECKPOINT = 0.8;

export function getRequestResultNoticeParams(
    allRequestItems: number,
    successItems: number
): {
    noticeType: NoticeType;
    noticeMessageType: NoticeType;
} {
    const successProportion = successItems / allRequestItems;

    let noticeType: NoticeType;
    let noticeMessageType: NoticeType;

    if (successProportion === 1) {
        noticeType = NoticeType.success;
        noticeMessageType = NoticeType.success;
    } else if (successProportion === 0) {
        noticeType = NoticeType.error;
        noticeMessageType = NoticeType.error;
    } else if (successProportion <= ERROR_PROPORTION_CHECKPOINT) {
        noticeType = NoticeType.error;
        noticeMessageType = NoticeType.warning;
    } else if (successProportion >= SUCCESS_PROPORTION_CHECKPOINT) {
        noticeType = NoticeType.success;
        noticeMessageType = NoticeType.warning;
    } else {
        noticeType = NoticeType.warning;
        noticeMessageType = NoticeType.warning;
    }

    return {
        noticeType,
        noticeMessageType
    };
}

export function showRequestResultNoticeMessage(
    allRequestItems: number,
    successItems: number,
    message: string
): void {
    const successProportion = successItems / allRequestItems;

    if (successProportion <= ERROR_PROPORTION_CHECKPOINT) {
        showNoticeMessage(NoticeType.error, message);
    } else if (successProportion >= SUCCESS_PROPORTION_CHECKPOINT) {
        showNoticeMessage(NoticeType.success, message);
    } else {
        showNoticeMessage(NoticeType.warning, message);
    }
}
